
import { API, API_GET_ID } from '../../Config'

export const GetSingleCoupon= (id) => {
  return (
    API_GET_ID(API.singlecoupon,id)
  )
}
